import { GetStaticPropsContext } from 'next';

import CalendarTablePage from 'presentations/views/components/pages/apps/CalendarTablePage';
import { setBreadcrumbs } from 'presentations/views/helpers/breadcrumbs';
import {
  appCalendarPath,
  appCalendarTablePath,
  webPath,
} from 'presentations/routes/path';
import { gengoList } from 'usecases/app_calendar/jp/gengo';
import MainDocument from 'presentations/views/components/MainDocument';

interface ServerProps {
  locale: string;
  linkCanonical: string;
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const locale = 'ja';
  const props: ServerProps = {
    locale,
    linkCanonical: webPath(appCalendarTablePath(), context.locale),
  };
  return { props };
}

export default function Page(props: ServerProps) {
  const gengos = gengoList();
  const routes = setBreadcrumbs([
    { link: appCalendarPath(), title: 'カレンダー' },
    { title: 'すべてのカレンダー' },
  ]);
  const title = 'すべてのカレンダー';
  const description = '';
  return (
    <MainDocument
      title={title}
      description={description}
      locales={['ja']}
      linkCanonical={props.linkCanonical}
      isUseAdsense
    >
      <CalendarTablePage routes={routes} gengos={gengos} />
    </MainDocument>
  );
}
